import type { IComponent } from "@Components/Component";

import type { IContentContainer } from "../common/ContentContainer";
import type { ISearchCategories } from "./SearchCategories";
import { SearchCategories } from "./SearchCategories";
import type { ISearchResults } from "./SearchResults";
import { SearchResults } from "./SearchResults";

import * as cssPortal from "../shared/Portal.module.css";

export interface ISearch extends IComponent {
    results: ISearchResults;
    categories: ISearchCategories;
    contentContainers: IContentContainer;
}

export const Search = (props: ISearch) => (
    <div className={cssPortal.containerMargins}>
        <SearchResults {...props.results} />
        <div className={cssPortal.standardContainerV2}>
            <div className={cssPortal.setSectionColOne}>
                <SearchCategories {...props.categories} />
            </div>
        </div>
    </div>
);
